import type { FaireProductEntity } from "../../entity_types/product";

export const p_s89kafcfdg: FaireProductEntity = {
  token: "p_s89kafcfdg",
  type: "product",
  name: "Women's Exaggerated Collar Soft Lounge Cardigan",
  brandToken: "b_br6ji29u",
  brandName: "Softies",
  imageUrl: "https://cdn.faire.com/fastly/ea2544c569b10cbe3077f79122ee2b4489cc02787460f738ba96162c908ea74f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fd0234896d2f6b8d5c49bb9e8386bf1a1848e822a98b4449e36d2cee7e91ee13.jpeg",
    "https://cdn.faire.com/fastly/1675da07888016c4d4f65821f62433f57661147f23c86e26f979957a826aa937.jpeg",
    "https://cdn.faire.com/fastly/0b447d7cdb8dd83110c1eac8669b3b7cf2f01f979828c4644cfca6b3f0a62b0b.png",
    "https://cdn.faire.com/fastly/06fbe50a241743b79b24f92a58c4fb58ca875d5c810dbf17a6f26fa09ec59862.jpeg",
    "https://cdn.faire.com/fastly/f8c6af10bc1bd17745add3137338c1e61c20edab71b6a12b0e8bd70a8bd2de15.jpeg",
    "https://cdn.faire.com/fastly/d4e74191315936a8b0e4aca4b8312d6699b00015371ba16085e8d0044ffaf6e8.jpeg",
    "https://cdn.faire.com/fastly/bb6015e5887e837f1defc708c9b74797b1e33e13a0751c78bc3afcd7e61e80c7.png",
    "https://cdn.faire.com/fastly/0a004f6ba453315722fa390e15feb38994e708a00feff457bd38759f681153f4.jpeg",
    "https://cdn.faire.com/fastly/384b7d790ac7cc8d66d46605455055f13f043091a9a4059a845a8b3bbccee051.jpeg",
    "https://cdn.faire.com/fastly/6ae355c203cf0fb53d192c2a67abb98770798ac956421a3ff867a20e4dfad8f8.jpeg",
    "https://cdn.faire.com/fastly/f4d9c94e23c86404fc4b88f2d26e07781ce549f67657312604d3c7b9d09415f6.png",
    "https://cdn.faire.com/fastly/bd75c4ac8a492aabc8bef29790ccc5a7b8c80a530dea2913c7c5fa4e7cf4e72b.jpeg",
    "https://cdn.faire.com/fastly/db6419007c419e1d2e6045b1bf2fb9b16fef910e85498739efd6fe5c80cffdb5.jpeg",
    "https://cdn.faire.com/fastly/baea1bb393cb11e1025395b09b29328033002257b9fde573430eb008affd4aca.jpeg",
    "https://cdn.faire.com/fastly/e5fc158b6901243dd427f99d10b51f7b58551e5762c68735da02d8dda1fae95d.png"
  ],
  priceDollars: 60,
  description: "Some layers simply complete an outfit—this one elevates it. Designed to bring effortless sophistication to your everyday wardrobe.\n\nFabrication:\nCrafted from DreamTech fabric, this cardigan offers a cool-to-the-touch feel with a smooth, elevated finish. \n\nFeatures:\n● Statement exaggerated collar adds a modern, sophisticated touch\n● Open-front cardigan silhouette makes layering effortless\n● Four-way stretch fabric provides all-day comfort and ease of movement\n● Shape-retaining construction helps maintain a polished appearance\n\nMaterials & Care:\n● 81% Rayon, 14% Nylon, 5% Spandex\n● Machine wash cold with like colors\n● Tumble dry low; do not bleach\n\nBest For:\n● Layering over everyday essentials\n● Travel and life on the go\n● Elevating casual looks with effortless polish\n",
  tags: [],
  msrpDollars: 129,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-09-02T03:47:15.724Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
